module.exports = __webpack_public_path__ + "static/media/c2.2716abab.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/work/c2.png
// module id = 47
// module chunks = 0